/* @flow weak */
import Raven from 'raven-js'
// bluebird error catching
const register = unhandledRejection => unhandledRejection(event => {
  event.preventDefault()
  const { reason: error } = event.detail
  if (process.env.NODE_ENV === 'production') {
    Raven.captureException(error)
  } else {
    /* eslint-disable no-console */
    console.warn(error)
  }
})

const reportingMiddleware = () => next => action => next(action)

const configureReporting = (options) => {
  const { appVersion, sentryUrl, unhandledRejection } = options
  Raven.config(sentryUrl, {
    // gist.github.com/impressiver/5092952
    ignoreErrors: [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage',
      // Firebase
      'Access is denied.',
      'An internal error has occurred.',
      'PERMISSION_DENIED: Permission denied',
      'A network error (such as timeout, interrupted connection or unreachable host) has occurred',
    ],
    ignoreUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
    ],
    release: appVersion,
  }).install()
  register(unhandledRejection)
  return reportingMiddleware
}

export default configureReporting



// WEBPACK FOOTER //
// ./src/common/configure/reporting.js